module.exports = __webpack_public_path__ + "assets/img/home-product-advantage.20c5b8d0.png";